document.addEventListener('DOMContentLoaded', function() {
    // Get all clickable tab buttons and content sections
    const tabButtons = document.querySelectorAll('.regulations__aside--button--action');
    const contentSections = document.querySelectorAll('.regulations__content--section');
    const contentContainer = document.querySelector('.regulations__content');
    
    console.log('Tab buttons found:', tabButtons.length);
    console.log('Content sections found:', contentSections.length);
    
    // Function to check if we're on mobile/tablet (responsive breakpoint)
    function isMobileView() {
        return window.innerWidth < 1024; // Adjust breakpoint as needed
    }
    
    // Function to scroll to content container smoothly
    function scrollToContent() {
        if (isMobileView() && contentContainer) {
            const offsetTop = contentContainer.offsetTop - 20; // 20px offset from top
            window.scrollTo({
                top: offsetTop,
                behavior: 'smooth'
            });
            console.log('Scrolled to content container');
        }
    }
    
    // Function to create navigation buttons for mobile
    function createNavigationButtons() {
        contentSections.forEach((section, index) => {
            // Remove existing navigation buttons if any
            const existingNav = section.querySelector('.regulations__nav-buttons');
            if (existingNav) {
                existingNav.remove();
            }
            
            // Create navigation container
            const navContainer = document.createElement('div');
            navContainer.className = 'regulations__nav-buttons';
            
            // Previous button
            if (index > 0) {
                const prevButton = document.createElement('button');
                prevButton.className = 'regulations__nav-btn regulations__nav-btn--prev button button-lg';
                prevButton.innerHTML = '← Anterior';
                prevButton.addEventListener('click', () => {
                    switchTab(index - 1);
                });
                navContainer.appendChild(prevButton);
            }
            
            // Next button
            if (index < contentSections.length - 1) {
                const nextButton = document.createElement('button');
                nextButton.className = 'regulations__nav-btn regulations__nav-btn--next button button-lg';
                nextButton.innerHTML = 'Siguiente →';
                nextButton.addEventListener('click', () => {
                    switchTab(index + 1);
                });
                navContainer.appendChild(nextButton);
            }
            
            // Add navigation buttons to section if any buttons were created
            if (navContainer.children.length > 0) {
                section.appendChild(navContainer);
            }
        });
    }
    
    // Function to switch tabs
    function switchTab(targetIndex) {
        // Remove active class from all buttons and sections
        tabButtons.forEach(button => button.classList.remove('isActive'));
        contentSections.forEach(section => section.classList.remove('isActive'));
        
        // Add active class to target button and section
        if (tabButtons[targetIndex]) {
            tabButtons[targetIndex].classList.add('isActive');
            console.log('Activated tab button:', targetIndex);
        }
        if (contentSections[targetIndex]) {
            contentSections[targetIndex].classList.add('isActive');
            console.log('Activated content section:', targetIndex);
        }
        
        // Scroll to content on mobile after a short delay to allow transition
        setTimeout(() => {
            scrollToContent();
        }, 100);
    }
    
    // Add click event listeners to tab buttons
    tabButtons.forEach((button, index) => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            console.log('Tab clicked:', index, button.textContent.trim());
            switchTab(index);
        });
    });
    
    // Create navigation buttons for mobile
    createNavigationButtons();
    
    // Ensure first tab is active on load (fallback)
    if (tabButtons.length > 0 && contentSections.length > 0) {
        const activeButton = document.querySelector('.regulations__aside--button--action.isActive');
        const activeSection = document.querySelector('.regulations__content--section.isActive');
        
        console.log('Active button found:', !!activeButton);
        console.log('Active section found:', !!activeSection);
        
        // If no active tab is found, activate the first one
        if (!activeButton || !activeSection) {
            console.log('No active tab found, activating first tab');
            switchTab(0);
        }
    }
    
    // Handle window resize to update mobile view detection
    window.addEventListener('resize', function() {
        console.log('Window resized, mobile view:', isMobileView());
        // Recreate navigation buttons on resize
        createNavigationButtons();
    });
});